import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import PageTitle from "../../layouts/PageTitle";
import { addDuration, getDurationById, updateDuration } from "../../../services/DurationService";
import Swal from "sweetalert2";

const AddDuration = () => {
  const [loading, setLoading] = useState(false);
  const [durationName, setDurationName] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchDuration = async () => {
        try {
          setLoading(true);
          const response = await getDurationById(id);
          const duration = response?.data;
          setDurationName(duration?.data?.title);
        } catch (err) {
          console.error("Error fetching duration:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchDuration();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!durationName.trim()) {
      newErrors.durationName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const durationData = { title: durationName };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING COUNTRY ---
        await updateDuration(id, durationData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Duration details updated successfully",
        });
        navigate("/duration", {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        });
      } else {
        // --- CREATE NEW COUNTRY ---
        const response = await addDuration(durationData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Duration added successfully",
          });
          navigate("/duration", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Duration" : "Add Duration"}`}
        motherMenu="Duration"
        activeMenuLink={`${id ? `edit-duration/${id}` : "add-duration"}`}
        motherMenuLink={"duration"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/duration", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Duration List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={durationName} // bind value
                        onChange={(e) => setDurationName(e.target.value)} // update state
                      />
                      {errors?.durationName && (
                        <div className="text-danger mb-3 mt-1">
                          {errors.durationName}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/duration", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddDuration;
